module.exports = __webpack_public_path__ + "img/goBg2.727161bf.png";